<template>
    <app-layout ref="lo" title="Dashboard">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Dashboard
            </h2>
        </template>

        <div class="">
            <section class="text-gray-600 body-font">

                <div class="bg-gray-100 py-4">
                    <div class="mx-auto max-w-7xl">
                        <div
                            class="mx-auto max-w-7xl pt-4 pb-6 sm:px-6 md:flex md:items-center md:justify-between md:space-x-5 lg:max-w-7xl lg:px-6">
                            <div class="flex items-center space-x-5">
                                <div class="flex-shrink-0">
                                    <div class="relative">
                                        <img class="h-16 w-16 rounded-full"
                                             src="https://images.unsplash.com/photo-1463453091185-61582044d556?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                                             alt=""/>
                                        <span class="absolute inset-0 rounded-full shadow-inner" aria-hidden="true"/>
                                    </div>
                                </div>
                                <div>
                                    <h1 class="text-2xl font-bold text-gray-900 uppercase">{{
                                            $page.props.user.fullname
                                        }}</h1>
                                    <p class="text-sm font-medium text-gray-500"><a href="#"
                                                                                    class="text-gray-900">{{
                                            $page.props.user.email
                                        }}</a>
                                    </p>
                                </div>
                            </div>
                            <div
                                class="mt-6 flex flex-col-reverse justify-stretch space-y-4 space-y-reverse sm:flex-row-reverse sm:justify-end sm:space-x-3 sm:space-y-0 sm:space-x-reverse md:mt-0 md:flex-row md:space-x-3">
                                <a type="button" :href="route('profile.show')"
                                   class="inline-flex items-center justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">
                                    Profile
                                </a>
                            </div>
                        </div>
                        <div class="px-6">
                            <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
                                <div v-for="item in stats" :key="item.id"
                                     class="relative overflow-hidden rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
                                    <dt>
                                        <div class="absolute rounded-md bg-indigo-500 p-3">
                                            <component :is="item.icon" class="h-6 w-6 text-white" aria-hidden="true"/>
                                        </div>
                                        <p class="ml-16 truncate text-sm font-medium text-gray-500">{{ item.name }}</p>
                                    </dt>
                                    <dd class="ml-16 flex items-baseline pb-6 sm:pb-7">
                                        <p class="text-2xl font-semibold text-gray-900">{{ item.stat }}</p>
                                        <p v-if="item.statMinus !== 0"
                                           class="ml-2 flex items-baseline text-sm font-semibold text-red-600">
                                            <ArrowDownIcon class="h-5 w-5 text-red-500" aria-hidden="true"/>
                                            <span class="sr-only">Decreased by</span>
                                            {{ item.statMinus }}
                                        </p>
                                        <p v-if="item.statPlus !== 0"
                                           class="ml-2 flex items-baseline text-sm font-semibold text-green-600">
                                            <ArrowUpIcon class="h-5 w-5 text-green-500" aria-hidden="true"/>
                                            <span class="sr-only">Increased by</span>
                                            {{ item.statPlus }}
                                        </p>
                                        <div class="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
                                            <div class="text-sm">
                                                <a :href="item.url"
                                                   class="font-medium text-indigo-600 hover:text-indigo-500"
                                                >Lihat Semua<span class="sr-only"> {{ item.name }} stats</span></a
                                                >
                                            </div>
                                        </div>
                                    </dd>
                                </div>
                            </dl>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from "vue";

import AppLayout from "@/Layouts/AppLayout";
import IconPenyedia from "@/Icons/Penyedia";
import IconUser from "@/Icons/User";
import Badge from "primevue/badge";

import IconAdd from "@/Icons/Add";
import {Link} from "@inertiajs/inertia-vue3";
import {
    ArrowLongLeftIcon,
    CheckIcon,
    HandThumbUpIcon,
    HomeIcon,
    MagnifyingGlassIcon,
    PaperClipIcon,
    QuestionMarkCircleIcon,
    UserIcon,
} from '@heroicons/vue/20/solid';
import {ArrowDownIcon, ArrowUpIcon} from '@heroicons/vue/20/solid'
import {CursorArrowRaysIcon, EnvelopeOpenIcon, UsersIcon} from '@heroicons/vue/24/outline'


export default defineComponent({
    components: {
        AppLayout,
        IconPenyedia,
        IconUser,
        Badge,
        IconAdd,
        Link,
    },
    data() {
        return {
            stats: [
                {
                    id: 'dokumen_pengadaan',
                    name: 'Dashboard Pengadaan',
                    stat: 0,
                    statMinus: 0,
                    statPlus: 0,
                    icon: UsersIcon,
                    url: route('dokumen_pengadaan.dashboard'),
                },
            ],
            eventTypes: [
                {
                    id: 1,
                    name: 'applied',
                    bgColorClass: 'bg-blue-500',
                    icon: UserIcon,
                },
                {
                    id: 2,
                    name: 'advanced',
                    bgColorClass: 'bg-indigo-500',
                    icon: QuestionMarkCircleIcon,
                },
            ],
            timeline: [
                {
                    id: 1,
                    type: {
                        id: 1,
                        name: 'applied',
                        bgColorClass: 'bg-blue-500',
                        icon: UserIcon,
                    },
                    content: 'Applied to',
                    target: 'Front End Developer',
                    date: 'Sep 20',
                    datetime: '2020-09-20',
                },
                {
                    id: 2,
                    type: {
                        id: 2,
                        name: 'advanced',
                        bgColorClass: 'bg-indigo-500',
                        icon: QuestionMarkCircleIcon,
                    },
                    content: 'Advanced to phone screening by',
                    target: 'Bethany Blake',
                    date: 'Sep 22',
                    datetime: '2020-09-22',
                },
            ]
        };
    },
    methods: {
        async getNotifikasi() {
            const {data} = await axios.get(
                route("dokumen_pengadaan.notifikasi")
            );
            this.stats.forEach(stat => {
                if (data[stat.id] !== undefined) {
                    stat.stat = data[stat.id].stat || stat.stat;
                    stat.statMinus = data[stat.id].statMinus || stat.statMinus;
                    stat.statPlus = data[stat.id].statPlus || stat.statPlus;
                }
            });

        },
    },
    mounted() {
        console.log("Page props : ", this.$page.props);
        this.getNotifikasi();
    },


});

</script>

<script setup lang="ts">
</script>
